import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AddMemebers from "../AddMemeber/AddMemebers";
import "../CreteMoreGroup/createMoreGroups.css";
import DeleteGroup from "../Delete/DeleteGroup";
import DeleteGroupMember from "../Delete/DeleteGroupMember";
import FotterGroup from "../Fotter/FotterGroup";
import GroupMemberList from "../GroupMemberList/GroupMemberList";
import axios from "../../axios"
import { lightGreen } from "@mui/material/colors";
import FilterBox from "./Filter_Box/FilterBox";
import { Popup } from "semantic-ui-react";
import { IP } from "../../internalServer";
import SuccessMemberAdded from "../SucessGroup/SuccessMemberAdded";
// let IP = "http://167.71.237.255:3001";

const groupMap = new Map();
export default function CreateMoreGroups() {
  const [click, setClick] = useState(false);
  const [message, setMessage] = useState(false);

  const [click1, setClick1] = useState(false);
  const [stand, setStand] = useState()
  const [grop, setGrop] = useState()
  const [add, setAdd] = useState();
  const [member, setMember] = useState(false);
  const [groups, setGroups] = useState();
  const [dropdownLists, setDropdownLists] = useState({
    standards: null,
    sections: null,
    assessmentTypes: null,
    sub: null,
  });
  const { standards, sections, sub } = dropdownLists;
  const handelClick1 = () => {
    setClick1(true);

  };
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  let school_id = JSON.parse(localStorage.getItem("schoolId"));
  
  const [filter, setFilter] = useState({
    subjects: [],
    type: [],
    clicked: false,
  })
  const { clicked, subjects, type } = filter;

  useEffect(() => {
    async function fetchData() {
      try {
        let resGroups = await axios.get(
          `api/v1/group/filterForTeacher/teacherId/${teacher_id}?_page=1&_limit=20` +
            `${stand ? `&standardId=${stand}` : ""}` +
            `${subjects.length > 0 ? `&subjectId=${subjects}` : ""}` +
            `${type?.length > 0 ? `&type=${type}` : ""}` +
            `${stand > 0 ? `&standardId=${stand}` : ""}`
        );
          console.log(resGroups)
        if (resGroups && resGroups.data.data) {
          const initialGroups = resGroups.data.data.map(group => ({ ...group, memberCount: 0 }));
          setGroups(initialGroups);
          for (const group of initialGroups) {
            let resMember = await axios.get(`api/v1/group/getById/${group?.id}?isFullFledged=true`);
            if (resMember && resMember.data.data) {
              setGroups(prevGroups => {
                return prevGroups.map(gr => {
                  if (gr.id === group.id) {
                    return { ...gr, memberCount: resMember.data.data.member?.length || 0 };
                  }
                  return gr;
                });
              });
            }
          }
          setClick1(false);
          setGrop(); 
        }

      } catch (error) {
        console.log(error);
      }
    }
    fetchData();
  }, [clicked, stand, subjects, type, teacher_id]);
  

  useEffect(() => {

    const getLIst = async () => {
      try {
        let standard = await axios.get(`/api/v1/school/standard/get/school/${school_id}`);
        let section = await axios.get(`/api/v1/school/section/get/school/${school_id}`);
        let subject = await axios.get(`/api/v1/school/subject/get/school/${school_id}`);
        setDropdownLists((prev) => ({
          ...prev,
          standards: standard.data.data,
          sub: subject.data.data,
          sections: section.data.data
        }));
      } catch (error) {
        console.log(error);
      }
    };

    getLIst()

  }, []);

  const [d, setD] = useState()
  const [isPopupOpen, setIsPopupOpen] = useState(false)
  
  const [sortedStandards, setSortedStandards] = useState([]);

  useEffect(() => {
    if (standards) {
      const sortedStd = [...standards].sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        return nameA.localeCompare(nameB);
      });

      setSortedStandards(sortedStd);
    }
  }, [standards]);
  return (
    <>
      {/* {!click && ( */}
      <div className="all_createGroup_container" >
        <div className="d-flex">
          <div className="col-md-5 col-11 ">
            <div className="yours_group col-md-6 p-0 tabSizeContainer" >Your Groups</div>
            <div className="d-flex align-items-center mt-3 mb-3 gap-3 tabSize" style={{width:"300px"}}>
              <select
                style={{ color: "#668598", height: "40px", width: "100%", margin:"0"}}
                className="form-select filter_class_section_Style"
                id=""
                onChange={(e) => setStand(e.target.value)}
              >
                <option value="">Select Class</option>
                {sortedStandards?.length > 0 &&
                sortedStandards?.map((standard, index) => (
                  <option
                    key={index}
                    value={standard?.id}
                    name={standard?.name}
                  >
                    {standard?.name}
                  </option>
                ))}
              </select>
              <Popup
                on="click"
                className="popup_filter_box"
                open={isPopupOpen}
                onClose={()=>{setIsPopupOpen(false)}}
                trigger={
                  <div
                    className="col-md-2 col-12 gap-2  filter_button"
                    onClick={() => {
                      setIsPopupOpen(!isPopupOpen);
                    }}
                  >
                    <img
                      src="/images/filter_icon.svg"
                      alt=""
                      onClick={() => {
                        setIsPopupOpen(!isPopupOpen);
                      }}
                    />
                    <span>Filter</span>
                  </div>
                }
                content={
                  <FilterBox
                    setFilter={setFilter}
                    filter={filter}
                    setIsPopupOpen={setIsPopupOpen}
                    sub={sub}
                  />
                }
                position="bottom center"
              />
            </div>
            <div className="classListScroll">
            {groups?.length > 0 && groups.map((group) => <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                background: group.isDeleted && "#CCD6DD"
              }}
              onClick={() => { handelClick1(); setGrop(group); if (isPopupOpen) { setIsPopupOpen(false) } }}
              className={`total_Your_group col-md-9 col-12 ${grop?.id === group?.id && 'clickedGroup'}`}
            >
              <div className="d-flex align-items-center">
                <img
                  className="group_profile_img"
                  // src="/group-img/groupImg1.svg"
                  src={group.profile_picture
                    ? `${IP}${group.profile_picture.substring(
                        group.profile_picture.indexOf("/")
                      )}`
                    : "/group-img/groupImg1.svg"}
                  alt=""
                ></img>
                <div>
                  <div className="class_group">{group.name}</div>
                  <div className="parent_group">{group.type} ● {group?.memberCount} Members</div>
                </div>
              </div>
              {teacher_id === group.teacher.id && !group.isDeleted && <div>
                <img
                  className="dusbin_box_group"
                  alt=""
                  src="/group-img/delete_group_icon.svg"
                  onClick={() => { setClick(true); setGrop(group) }}
                ></img>
              </div>}
            </div>)}
            <div onClick={() => isPopupOpen ? setIsPopupOpen(false) : ''}>
              <Link to="/createGroups">
                <button className="creteBtn col-12">
                  Create More Groups
                </button>
              </Link>
            </div>
            </div>
          </div>

          <div onClick={() => isPopupOpen ? setIsPopupOpen(false) : ''} className="col-md-6 col-11">
            {click1 ? (
              <GroupMemberList list={grop} setAdd={setAdd} setD={setD} setMember={setMember} add={add} member={member}/>
            ) : <div className="d-flex flex-column align-items-center">
              <img src="/images/man.png" alt="" />
              <span style={{
                color: "#455A64",
                fontSize: "20px",
                fontWeight: 600,
                marginTop: "20px"
              }}>Create and manage groups for easy interaction experience.</span>
            </div>}
          </div>
        </div>
      </div>
      {/* <FotterGroup /> */}

      {click && <DeleteGroup list={grop} permision={setClick} />}

      {member && <DeleteGroupMember list={grop} data={d} setMember={setMember} />}

      {add && <AddMemebers list={grop} setAdd={setAdd} setMessage={setMessage}/>}
      {message && <SuccessMemberAdded setMessage={setMessage}/>}

    </>
  );
}
